var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex mb-3" },
        [
          _c("custom-light-card", {
            staticStyle: { width: "70%" },
            attrs: {
              icon: _vm.technicianPosition.icon,
              specificTitleClasses: _vm.item.scheduled ? "success--text" : "",
              status: _vm.getStatus(this.item),
              subtitle: _vm.technicianPosition.position,
              title: _vm.item.full_name
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mx-auto" },
            [
              _vm.affectation
                ? _c(
                    "v-row",
                    { staticClass: "justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "align-self-end",
                          attrs: {
                            color: "primary",
                            disabled: _vm.isAssigned,
                            small: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("input", _vm.item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isAssigned
                                  ? _vm.generateMessage("tech_search.assigned")
                                  : _vm.generateMessage("tech_search.assign")
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.request.entity_ordo === "O" &&
              _vm.request.property &&
              _vm.request.property.request_ordo === "O" &&
              _vm.request.rejected === "N" &&
              ["1", "2"].includes(_vm.request.status)
                ? _c(
                    "v-row",
                    { staticClass: "mt-1 justify-end" },
                    [
                      _c("LinkToP2O", {
                        staticClass: "mx-2",
                        attrs: {
                          isText: false,
                          color: "primary",
                          "request-id": _vm.request.id,
                          "is-paused": _vm.request.is_paused === "O",
                          "is-assigned": _vm.request.dispatched === "O"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("custom-simple-table", {
        attrs: {
          hoverTable: "",
          item: _vm.transformedItem,
          "i18-path": "tech_search.fields",
          specificClasses: _vm.technicianTableStyle,
          "table-keys": _vm.technicianTableKeys
        },
        scopedSlots: _vm._u([
          {
            key: "arrayItem",
            fn: function({ item }) {
              return [
                item.label
                  ? _c(
                      "div",
                      { staticClass: "d-flex arrayDetails" },
                      [
                        _c("truncate-text-with-hover", {
                          attrs: { text: item.label, length: 25 }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          { staticClass: "ml-1", attrs: { small: "" } },
                          [_vm._v(_vm._s(item.icon))]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "font-weight-bold my-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.generateMessage("tech_search.tech_interventions")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "loader",
        { attrs: { "is-loading": _vm.isLoadingInProgressItvs } },
        [
          _vm.inProgressTechItvs && _vm.inProgressTechItvs.length
            ? _c(
                "v-simple-table",
                { staticClass: "background", attrs: { dense: "" } },
                [
                  _c(
                    "tbody",
                    _vm._l(_vm.inProgressTechItvs, function(
                      intervention,
                      index
                    ) {
                      return _c("tr", { key: index }, [
                        _c(
                          "td",
                          { staticClass: "caption pa-0 font-weight-bold" },
                          [
                            _c("intervention-date", {
                              attrs: {
                                date: _vm._f("transformDate")(
                                  intervention.event_datetime
                                ),
                                status: _vm._f("getStatus")(intervention)
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "caption px-2" },
                          [
                            _c("truncate-text-with-hover", {
                              attrs: {
                                text: intervention.description,
                                length: 7
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "caption pa-0 text-end" },
                          [
                            _c("truncate-text-with-hover", {
                              attrs: {
                                text: `${intervention.property_name}-${intervention.property_code}`,
                                length: 11
                              }
                            })
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            : _c("div", { staticClass: "caption font-italic" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.generateMessage("tech_search.no_data_in_progress")
                    ) +
                    "\n    "
                )
              ]),
          _vm._v(" "),
          _c(
            "loader",
            { attrs: { "is-loading": _vm.isLoadingScheduledItvs } },
            [
              _vm.scheduledTechItvs && _vm.scheduledTechItvs.length
                ? _c(
                    "v-simple-table",
                    { staticClass: "background", attrs: { dense: "" } },
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.scheduledTechItvs, function(
                          intervention,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              { staticClass: "caption pa-0 font-weight-bold" },
                              [
                                _c("intervention-date", {
                                  attrs: {
                                    date: _vm._f("transformDate")(
                                      intervention.event_datetime
                                    ),
                                    status: _vm._f("getStatus")(intervention)
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "caption px-2" },
                              [
                                _c("truncate-text-with-hover", {
                                  attrs: {
                                    text: intervention.description,
                                    length: 7
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "caption pa-0 text-end" },
                              [
                                _c("truncate-text-with-hover", {
                                  attrs: {
                                    text: `${intervention.property_name}-${intervention.property_code}`,
                                    length: 11
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  )
                : _c("div", { staticClass: "caption font-italic" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage("tech_search.no_data_scheduled")
                        ) +
                        "\n      "
                    )
                  ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }